export const KEY_SPACE = 'Space';
export const KEY_ENTER = 'Enter';
export const KEY_ARROW_DOWN = 'ArrowDown';
export const KEY_ARROW_UP = 'ArrowUp';
export const KEY_ARROW_LEFT = 'ArrowLeft';
export const KEY_ARROW_RIGHT = 'ArrowRight';
export const KEY_ESCAPE = 'Escape';
export const KEY_TAB = 'Tab';
export const KEY_BACKSPACE = 'Backspace';
export const KEY_A = 'a';
export const KEY_D = 'd';
export const KEY_W = 'w';
export const KEY_S = 's';
